<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <!-- custom (redesign Modeloja): a ilustração do upstream (`no-chat.svg`, 495×387, azul e
       lavanda) saiu. Dois motivos, nessa ordem:

       1. Ela é a maior superfície de cor do produto e usa exatamente a paleta que o resto
          do redesign expurgou. Um desenho de 500px de largura no meio da tela mais visitada
          desfaz sozinho o trabalho de unificação de cor.
       2. Escala. Um blob ilustrado é uma piada contada uma vez; quem abre o painel vinte
          vezes por dia não quer a piada, quer saber em meio segundo que não há nada ali.

       O que fica é o MESMO padrão que a coluna vazia do board do CRM já usa (glifo neutro
       pequeno + uma linha) — a repetição é de propósito: vazio deve parecer vazio do mesmo
       jeito em todo lugar do produto, senão o usuário para para interpretar. -->
  <div class="flex flex-col items-center justify-center h-full px-6">
    <span class="i-lucide-inbox size-6 text-n-slate-8" />
    <span class="mt-2.5 text-sm text-n-slate-11 font-medium text-center">
      {{ message }}
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
